import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconPerson } from '@/assets/svgs/icon-persona.svg';
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import rem from '@/utils/rem';


const CardList = ({ item, index }) => {
	return (<div className="layout-card__content_row" key={index}>
		<div className="layout-card__content__text">
			{item?.name}
		</div>
	</div>)
}

const DataElementList = ({ flow }) => {
	return (flow && flow?.length > 0 ?
		flow?.map((itemObjValue, index) => (
			<CardList key={index} item={itemObjValue} index={index} />
		)) :
		<div className="layout-card__content_row">
			<div className="layout-card__content__text">
				No data element
			</div>
		</div>
	)
}

const PersonaInfoModal = ({ visible, hide, persona }) => {

	return (
		<Modal visible={visible} variant='medium' close={hide}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className='persona-info-modal__icon'>
										<IconPerson />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										{persona?.name || "-"}
									</div>

								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="persona-info-modal">
							<div className="persona-info-modal__description">
								{persona?.description || "-"}
							</div>
							<hr />
							<div className="persona-info-modal__title">
								Value Drivers
							</div>
							<div className="persona-info-modal__value">
								{
									persona?.keyvaluedrivers?.length > 0 ?
										persona?.keyvaluedrivers?.map((item, index) => (
											<div key={index} className="layout-card__content__text">
												{item}
											</div>
										))
										:
										<div className="layout-card__content__text">
											-
										</div>
								}
							</div>
							<hr />
							<div className="persona-info-modal__data-element">
								<div className="persona-info-modal__data-element-content">
									<div className="persona-info-modal__title ">
										Recommended to Contribute
									</div>
									<DataElementList flow={persona?.contributes} />
								</div>
								<div className="persona-info-modal__consume-data-element">
									<div className="persona-info-modal__title">
										Recommended to Consume
									</div>
									<DataElementList flow={persona?.consumes} />
								</div>
							</div>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
			</CardConfigure>
		</Modal>
	)
};

export default PersonaInfoModal;
